module.exports = __webpack_public_path__ + "static/media/retire_hero.e5e3f72a.jpg";